import {isError, isFunction, isObject, isString} from 'lodash';

export default {
  setUser(user) {
    if (isObject(user)) { // MLD-3045
      if (isObject(window.Bugsnag) && isFunction(window.Bugsnag.setUser)) {
        try {
          Bugsnag.setUser(user.id, user.email, user.name);
        } catch (e) {
          console.log('Bugsnag.setUser exception', e);
        }
      }
    } else {
      if (isObject(window.Bugsnag) && isFunction(window.Bugsnag.setUser)) {
        try {
          Bugsnag.setUser(null, null, null);
        } catch (e) {
          console.log('Bugsnag.setUser exception', e);
        }
      }
    }
  },
  notify(error) { // MLD-4918
    try { // Make sure the Bugsnag object exists and the notify function exists.
      if (isObject(window.Bugsnag) && isFunction(window.Bugsnag.notify)) {
        if (isError(error)) { // MLD-5144
          Bugsnag.notify(error);
        } else if (isString(error)) {
          Bugsnag.notify(new Error(error));
        } else {
          Bugsnag.notify(new Error('Bugsnag caught an error but there was no information.'));
        }
      } else {
        console.log('Bugsnag is disabled', error);
      }
    } catch (e) {
      console.log('Bugsnag.notify exception', e);
    }
  }
}
